import { render, staticRenderFns } from "./mobile-prepaid.vue?vue&type=template&id=2267200b&scoped=true"
import script from "./mobile-prepaid.vue?vue&type=script&lang=js"
export * from "./mobile-prepaid.vue?vue&type=script&lang=js"
import style0 from "./mobile-prepaid.vue?vue&type=style&index=0&id=2267200b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267200b",
  null
  
)

export default component.exports